import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MatCheckbox } from '@angular/material';
import { PayrollSelectFilter } from 'app/main/payroll/payroll.types';

@Component({
  selector: 'app-payroll-filter',
  templateUrl: './payroll-filter.component.html',
  styleUrls: ['./payroll-filter.component.scss'],
})
export class PayrollFilterComponent implements OnInit {
  @Input() lists: PayrollSelectFilter[];
  checkedKeys: string[];
  
  @Output() applyFilter = new EventEmitter();

  constructor() {
    
  }

  ngOnInit(): void {}

  // tslint:disable-next-line: typedef
  checkboxChange(event: MatCheckbox, item: PayrollSelectFilter) {
    item.checked = event.checked;

    if (item.children) {
      // check first children elements
      item.children = item.children.map((d) => {
        if (d.children) {
          // check second children elements
          d.children = d.children.map((i) => {
            i.checked = event.checked;
            return i;
          });
        }
        d.checked = event.checked;
        return d;
      });
    }

    const keys = {};
    // Refresh checked list
    for (const p of this.lists) {
      if (p.children) {
        p.checked = true;
        for (const child of p.children) {
          if (child.children) {
            child.checked = true;
            for (const deepChild of child.children) {
              if (!deepChild.checked) {
                child.checked = false;
              }
              keys[deepChild.key] = deepChild.checked;
            }
          }
          if (!child.checked) {
            p.checked = false;
          }

          keys[child.key] = child.checked;
        }
      }

      keys[p.key] = p.checked;
    }
    this.checkedKeys = Object.keys(keys).filter((k) => !keys[k]);
    this.applyFilter.emit({ keys: this.checkedKeys, states: this.lists });
  }

}
